export default __webpack_public_path__ + "static/map-d03ee0161ee157a655fcbbdf1d67afa9.png";